import {
  ApolloClient, InMemoryCache, HttpLink, ApolloLink,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import * as moment from 'moment-timezone';
import firebase from './firebase';

const cache = new InMemoryCache({
  typePolicies: {
    ProfileObjectType: {
      fields: {
        examTargets: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          merge(_, incoming): any {
            return incoming;
          },
        },
      },
    },
    ActivityObjectType: {
      keyFields: ['_id'],
    },
    Notification: {
      keyFields: ['_id'],
      fields: {
        links: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          merge(_, incoming): any {
            return incoming;
          },
        },
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      merge(_, incoming): any {
        return incoming;
      },
    },
    ActivityFlashcardObjectType: {
      fields: {
        flashcards: {
          merge: false,
        },
      },
    },
  },
});

const communityHttpLink = new HttpLink({
  uri: String(process.env.REACT_APP_API_URL),
});

const contentsHttpLink = new HttpLink({
  uri: `${String(process.env.REACT_APP_CONTENTS_API_URL)}/graphql`,
});

const authLink = setContext(async (_, { headers }) => {
  const { currentUser } = firebase.auth();

  if (!currentUser) {
    return {
      headers,
    };
  }

  let token = '';
  try {
    token = await currentUser.getIdToken();
  } catch (error) {
    console.error(error);
  }

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
      'X-Timezone': moment.tz.guess(),
    },
  };
});

const client = new ApolloClient({
  link: ApolloLink.from([authLink, ApolloLink.split(
    (operation) => operation.getContext().clientName === 'contents',
    contentsHttpLink,
    communityHttpLink,
  )]),
  cache,
});

export default client;
